import {type ModalProps, message, Modal} from 'antd';
import {useForm} from 'form-render';
import Style from './index.module.scss';
import {useMutation} from 'react-query';
import useSchema from 'Utils/Hooks/useSchema';
import JsonForm from 'Components/JsonForm';
import {AgentDataSet} from '../../../agentDataSetService';

interface Props extends ModalProps {
    onOk: () => void;
    agentId: string;
    data: AgentDataSet.List;
}

const Index = ({onOk, agentId, data, ...props}: Props) => {
    const form = useForm();

    const onSave = useMutation({
        mutationFn: AgentDataSet.save,
        onSuccess: () => {
            message.success('成功!');
            onOk();
        },
    });

    const {schema} = useSchema({
        type: 'object',
        column: 1,
        displayType: 'row',
        labelCol: 5,
        fieldCol: 18,
        properties: {
            priority: {
                title: '优先级',
                required: true,
                type: 'number',
            },
            enabled: {
                required: true,
                type: 'boolean',
                title: '启用',
                widget: 'switch',
            },
        },
    });

    function onFinish(formData: AgentDataSet.Form) {
        onSave.mutate({
            agentId,
            data: [
                {
                    ...data,
                    ...formData,
                },
            ],
        });
    }

    return (
        <Modal
            {...props}
            title={`编辑 DataSet关联`}
            width={600}
            confirmLoading={onSave.isLoading}
            onOk={form.submit}>
            <div className={Style.root}>
                <JsonForm
                    initialValues={data}
                    loading={onSave.isLoading}
                    onFinish={onFinish}
                    schema={schema}
                    form={form}
                />
            </div>
        </Modal>
    );
};

export default Index;
